// Catalog
$(document).ready(function(){

  $('.header__menu-opener.desktop').on('click', function(e){
    if ( menuCatalogIsOpen()) {
      menuCatalogClose();
    } else {
      menuCatalogOpen();
    }
  });
  $(document).on('click', function(e){
    if ( menuCatalogIsOpen()
      && !$(e.target).closest('.header__menu-opener').length
      && !$(e.target).is('.header__menu-opener')
      && !$(e.target).closest('.header__catalog').length
      && !$(e.target).is('.header__catalog')
    ) {
      menuCatalogClose();
    }
  });

  const cm = new CatalogMenu();

});
function menuCatalogIsOpen() {
  return $('body').hasClass('header-menu-open');
}
function menuCatalogOpen() {
  $('body').addClass('header-menu-open');
}
function menuCatalogClose() {
  $('body').removeClass('header-menu-open');
}

// Catalog desktop
class CatalogMenu {
  constructor() {
    const _this = this;

    this.$w = $('.header__catalog');
    this.$ul = this.$w.find('.header__catalog__level--1 ul');

    this.timerClose = {};

    this.$w.on('mouseenter', '.header__catalog__menu li', function(e) {
      _this.open($(this));
    });
    this.$w.on('mouseleave', '.header__catalog__menu li', function(e) {
      _this.close($(this));
    });

    this.$w.on('mouseenter', '.header__catalog__level', function(e) {
      const $li = $(this).data('li');
      _this.open($li);
    });
    this.$w.on('mouseleave', '.header__catalog__level', function(e) {
      const $li = $(this).data('li');
      _this.close($li);
    });
  }

  open($li) {
    const $ul = $li.find('> ul');
    if ( $ul.length ) {
      // console.log('open',$li.find('> a').text());

      const $ul2 = $ul.clone();
      const $level = $ul.closest('.header__catalog__level')
      const level = $level.data('level');
      const $level_next = this.$w.find('.header__catalog__level--'+(level + 1));

      if ( this.timerClose[level]) {
        clearTimeout(this.timerClose[level]);
      }

      const $lin = $level_next.data('li');
      if ( $lin && $level_next.data('li').is($li) ) {
        return;
      }

      $level_next.find('.header__catalog__menu').html('');
      $level_next.find('.header__catalog__menu').append($ul2);
      $level_next.addClass('header__catalog__level--open');

      $level.addClass('header__catalog__level--open2');
      const $lip = $level.data('li');
      if ( $lip ) {
        $lip.addClass('hover2');
      }

      $level.find('.header__catalog__menu li').removeClass('hover').removeClass('hover2');;
      $li.addClass('hover');

      $level_next.data('li', $li);
    }
  }

  close($li) {
    const _this = this;
    const $ul = $li.find('> ul');
    if ( $ul.length ) {
      // console.log('close',$li.find('> a').text());
      const $level = $ul.closest('.header__catalog__level');
      const level = $level.data('level');
      const $level_next = _this.$w.find('.header__catalog__level--'+(level + 1));
      const $lip = $level.data('li');

      this.timerClose[level] = setTimeout(function() {
        $level_next.data('li', null);
        $level_next.removeClass('header__catalog__level--open');
        $level.removeClass('header__catalog__level--open2');
        $li.removeClass('hover');
        if ( $lip ) {
          $lip.removeClass('hover2');
        }
      }, 100);
    }
  }

}

// Mobile menu
$(document).ready(function(){

  $('.header__menu-opener.mobile').on('click', function(e){
    if ( menuMobileIsOpen()) {
      menuMobileClose();
    } else {
      menuMobileOpen();
    }
  });
  $('.header__mm-close').on('click', function(e){
    menuMobileClose();
  });
  $(document).on('click', '.header__mm__menu a, .header__mm__sub__menu a', function(e){
    const $a = $(this);
    const $li = $a.closest('li');
    const $sub = $li.find('> ul');
    if ( $sub.length ) {
      e.preventDefault();
      menuMobileOpenSub($a);
    }
  });
  $(document).on('click', '.header__mm__sub__title', function(e){
    menuMobileBackSub ();
  });

});
function menuMobileIsOpen() {
  return $('body').hasClass('body--header-mm-open');
}
function menuMobileOpen() {
  $('body').addClass('body--header-mm-open');
  $('.header__mm').stop().slideDown(400);
}
function menuMobileClose() {
  $('body').removeClass('body--header-mm-open');
  $('.header__mm').stop().slideUp(400);
  menuMobileCloseSub();
}

let mmStack = [];
function menuMobileOpenSub ( $a, is_back ) {
  // If we're in sub, find the same link in the main
  if ( $a.closest('.header__mm__sub__menu').length ) {
    const m = $a.closest('li').data('menu');
    $a = $('.header__mm__menu li[data-menu="' + m + '"] > a').first();
  }

  const $li = $a.closest('li');
  const $sub = $li.find('> ul').clone();
  const $mm = $('.header__mm');
  const $mm_sub = $('.header__mm__sub');
  const $title = $mm_sub.find('.header__mm__sub__title__text');
  const $menu = $mm_sub.find('.header__mm__sub__menu');

  $title.text($a.text());
  $menu.html('');
  $menu.append($sub);

  $mm.addClass('header__mm--open');

  if ( !is_back ) {
    mmStack.push($a);
  }
}
function menuMobileBackSub () {
  mmStack.pop();
  const $a = mmStack[mmStack.length - 1];
  if ( !mmStack.length ) {
    menuMobileCloseSub();
  } else {
    menuMobileOpenSub($a, 1);
  }
}
function menuMobileCloseSub () {
  $('.header__mm').removeClass('header__mm--open');
  mmStack = [];
}

// ------------------ WAIT

function wait () {
  return '<div class="wait"></div>';
}
function remove_wait ( $wrap ) {
  $wrap.find('.wait').fadeOut(200, function () {
    jQuery(this).remove();
  });
}

// FORMS
$(document).ready(function(){
  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      // console.log(mutation);
      if (mutation.type === "childList") {
        $(mutation.addedNodes).filter('shopify-forms-embed').once('sw-form').each(function () {
          // const shadow = this.shadowRoot;
          // console.log(shadow);
          const href = $('header').data('form-assets-path');
          const link = document.createElement('link');
          link.setAttribute('rel', 'stylesheet');
          link.setAttribute('href', href);
          this.shadowRoot.appendChild(link);

          // const src = $('header').data('form-js-path');
          // const script = document.createElement('script');
          // script.type = 'text/javascript';
          // script.src = src;
          // this.shadowRoot.appendChild(script);
          const form = this.shadowRoot.querySelector('form');
          const $form = $(form);
          shopifyFormInit($form);

        });
      }
    }
  });
  observer.observe(document.body, {childList: true, subtree: true});
});

// Rapid search off
$(document).ready(function () {
  $('.search form').on('submit', function(e) {
    console.log(e);
    e.stopPropagation();
    return false;
  });
});


// Drawer
$(document).ready(function () {
  $('.fixed-link').on('click', function(e) {
    $('.fixed-link-drawer').addClass('fixed-link-drawer--active');
  });
  $(document).on('click', function (e) {
    if (
      !$(e.target).is('.fixed-link') && !$(e.target).closest('.fixed-link').length
      && !$(e.target).is('.fixed-link-drawer') && !$(e.target).closest('.fixed-link-drawer').length
    ) {
      $('.fixed-link-drawer').removeClass('fixed-link-drawer--active');
    }
  });
});

$(document).ready(function () {
  // External links - new tab
  const links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});
